import dayjs from 'rc-picker/node_modules/dayjs'
import { HttpResponse, httpService } from '../core/http'
import {
  NonPaginatedResponseData,
  PaginatedRequest,
  PaginatedResponseData
} from '../core/interfaces'
import { Order, OrderToSave, PaymentMethod } from '../entities'
import { PriceTables } from '../entities/price-tables'
import { dateFormat } from '../utils/format/dateFormat'

export const getPaymentMethods = async (
  query: PaginatedRequest<any>
): Promise<PaginatedResponseData<PaymentMethod>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      '/orders/payment-methods',
      {
        params: {
          ...query
        }
      }
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getAllOrders = async (
  query: PaginatedRequest<any>
): Promise<PaginatedResponseData<Order>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get('/orders', {
      params: {
        ...query
      }
    })

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getOrderById = async (
  id: string
): Promise<NonPaginatedResponseData<Order>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(`/orders/${id}`)
    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getAllPriceTables = async (
  query: PaginatedRequest<any>
): Promise<PaginatedResponseData<PriceTables>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      '/orders/price-lists',
      {
        params: {
          ...query
        }
      }
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const createOrder = async (payload: OrderToSave): Promise<any> => {
  try {
    const httpResponse: HttpResponse = await httpService.post(
      '/orders',
      payload
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const updateOrder = async (payload: any): Promise<any> => {
  try {
    const httpResponse: HttpResponse = await httpService.put(
      `/orders/${payload.budgetId}`,
      payload
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const approveOrder = async (id: string): Promise<any> => {
  try {
    const httpResponse: HttpResponse = await httpService.post(
      `/orders/${id}/approve`
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}
